import { AxiosResponse } from "axios";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import { TopCommodity, TopCommodityResponse } from "@/domain/entities/PosRevenue";

export class PosRevenueMapper {
  public convertCommodityFromApi(result: AxiosResponse<any>): ResponsePayloadV2 {
    const { data } = result;
    const payload = data?.data ?? {};

    const lastSyncAt: string = payload?.last_sync_at ?? "";
    const cityCode: string = payload?.city_code ?? "";

    const items: TopCommodity[] = Array.isArray(payload?.data)
      ? payload.data.map((item: any) => new TopCommodity({
          commodityName: item?.commodity_name ?? "",
          bookingAtPos: Number(item?.booking_at_pos ?? 0),
          bookingDestinationCity: item?.booking_destination_city ?? "",
          rank: Number(item?.rank ?? 0),
          lastSyncAt
        }))
      : [];

    const responseData = new TopCommodityResponse({
      lastSyncAt,
      cityCode,
      data: items
    });

    return new ResponsePayloadV2({
      success: data?.success ?? true,
      message: data?.message ?? "",
      data: responseData
    });
  }
}
